import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const HomeWrapper = styled(Grid)(() => ({
  minHeight: "100svh",
  backgroundColor: "#ffff",
  alignItems: "center",
  //padding: "0 80px",
  position: "relative",
  //overflow: "hidden",
}));

export const TitleText = styled(Typography)(() => ({
  color: "#101828",
  fontSize: "60px",
  fontWeight: 600,
  lineHeight: "72px",

  "@media (max-width:600px)": {
    fontSize: "36px",
    lineHeight: "44px",
  },
}));

export const SubTitleText = styled(Typography)(() => ({
  color: "#475467",
  fontSize: "20px",
  fontWeight: 400,
  lineHeight: "30px",

  "@media (max-width:600px)": {
    fontSize: "16px",
    lineHeight: "24px",
  },
}));
